import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import { LogOut } from '@clientWebServices/logout.service';
import MessageService from '@clientWebServices/message.service';

@invoke
export default class Form {
  static Instance: Form;

  constructor() {
    Form.Instance = this;

    globalEvent({
      type: 'click',
      events: [
        {
          action: 'log-out',
          callback: this.onLogOut,
        },
      ],
    });
  }

  onLogOut(e: Event) {
    e.preventDefault();
    e.stopPropagation();

    LogOut()
      .then((response) => {
        window.location.href = response?.data?.logoutRedirect?.trim() ? response.data.logoutRedirect : '/';
      })
      .catch((err) => {
        console.log(err);
        MessageService.Instance.displayDefaultErrorMessage();
      });
  }
}
